import {z} from 'zod';

export const userOption = z.object({
    id: z.string(),
    name: z.string(),
});

export type UserOption = z.infer<typeof userOption>;
